import React from 'react';
import './ResponsiveImage.css';

const ResponsiveImage = ({ 
  images, 
  alt, 
  className = "",
  loading = "lazy" 
}) => {
  return (
    <picture className={`responsive-image ${className}`}>
      <source 
        media="(max-width: 767px)" 
        srcSet={images.small} 
      />
      <source 
        media="(min-width: 768px) and (max-width: 1439px)" 
        srcSet={images.medium} 
      />
      {images.large && (
        <source 
          media="(min-width: 1440px)" 
          srcSet={images.large} 
        />
      )}
      <img 
        src={images.medium} 
        alt={alt}
        loading={loading}
        className="responsive-img"
      />
    </picture>
  );
};

export default ResponsiveImage;